export const formatTime = (time?: string | null): string => {
  if (!time) return "N/A";

  const parts = time.split(":");

  if (parts.length >= 2) {
    return `${parts[0]}:${parts[1]}`;
  }

  return time;
};
